export default __webpack_public_path__ + "static/logo_tidyllc_trans@2x-9fc771a3f92989f668183c26ddba4293.png";